function resume() {
    return (
        <div style={{background: 'linear-gradient(to bottom, #808080 0%, #FFFFFF 100%)'}}>
            <iframe title="Mat's Resume" src="https://drive.google.com/file/d/10Z6vn7-GDjml9voh-RXab7PuOx2Td9pv-jhMAQwgKxE/preview" width="100%" height="800" allow="autoplay"></iframe>
        </div>
    )
};

export default resume;